import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { AccountDetailBusinessHours } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/blocs/loaders/use-account-details-loader';
import { AccountDetailHoursPill } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/components/account-detail-hours-pill';
import { AccountDetailHoursSheet } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/components/account-detail-hours-sheet';
import { DAYS_OF_WEEK } from '@/utils/date';
import { formatHoursRange } from '@/utils/business-hours';
import { List, View } from '@usepepper/sprout-kit-ui';

export const MobileHours: React.FC<AccountDetailBusinessHours> = ({
  dayToHoursMap,
  isCurrentlyOpen,
  nextOpenSlot,
  orderedDays,
}) => {
  const [isSheetVisible, setIsSheetVisible] = useState(false);

  if (orderedDays.every((day) => !dayToHoursMap[day])) {
    return null;
  }

  return (
    <View>
      <AccountDetailHoursPill
        isCurrentlyOpen={isCurrentlyOpen}
        isExpanded={isSheetVisible}
        nextOpenSlot={nextOpenSlot}
        onPress={() => setIsSheetVisible(true)}
      />
      <AccountDetailHoursSheet
        isVisible={isSheetVisible}
        onClose={() => setIsSheetVisible(false)}
      >
        <List>
          {orderedDays.map((day, index) => {
            // orderedDays starts at today.
            const isToday = index === 0;
            const ranges = dayToHoursMap[day]?.map((entry) =>
              formatHoursRange(entry),
            ) ?? [i18n.t('closed')];

            return (
              <React.Fragment key={day}>
                {index > 0 ? <List.Separator /> : null}
                <List.Item paddingHorizontal={0}>
                  <List.Item.Content>
                    <List.Item.Title
                      color="$textPrimary"
                      fontSize="$md"
                      fontWeight={isToday ? '$medium' : '$normal'}
                    >
                      {i18n.t(DAYS_OF_WEEK[day])}
                    </List.Item.Title>
                  </List.Item.Content>
                  <View alignItems="flex-end">
                    {ranges.map((range, rangeIndex) => (
                      <List.Item.Value
                        color={isToday ? '$textPrimary' : '$textSecondary'}
                        fontSize="$md"
                        fontWeight="$medium"
                        key={`${day}-${rangeIndex}`}
                      >
                        {range}
                      </List.Item.Value>
                    ))}
                  </View>
                </List.Item>
              </React.Fragment>
            );
          })}
        </List>
      </AccountDetailHoursSheet>
    </View>
  );
};
